/**
 *
 * Recordings Page
 *
 * Handling recordings description slide up/down
 */

jQuery(document).ready(function () {

    jQuery('.itbl-recordings-symbol').click(function () {
        jQuery(this).parent().parent().find('.itbl-recordings-description').slideToggle();

        let expandIcon = jQuery(this).find('img');

        let plusIconSrc = expandIcon.attr('src').replace('minus', 'plus')
        let minusIconSrc = expandIcon.attr('src').replace('plus', 'minus');
      

        var src = (jQuery(this).find('img').attr('src').search('minus') !== -1)
            ? plusIconSrc
            : minusIconSrc;

        jQuery(this).find('img').attr('src', src);
    });


});